import { updateListing } from 'api/leads';
import { Button, InputField } from 'components';
import { useTanstackMutation } from 'hooks';
import { Lead } from 'models/Lead';
import { Modal } from 'ncoded-component-library';
import { FC } from 'react';
import { Field, Form } from 'react-final-form';
import toast from 'react-hot-toast';
import { queryClient } from 'react-query';
import { validateRequired } from 'validations';

type EditCompanyNameModalProps = {
  isOpen: boolean;
  onClose: () => void;
  lead: Lead;
};

const EditCompanyNameModal: FC<EditCompanyNameModalProps> = (props) => {
  const { isOpen, onClose, lead } = props;
  const { companyName } = lead;

  const { mutate: editCompanyNameMutation, isPending } = useTanstackMutation({
    onSuccess: (response: Lead) => {
      const { companyName } = response || {};
      queryClient.setQueryData(['lead', { id: lead._id }], {
        ...lead,
        companyName,
      });

      queryClient.invalidateQueries({ queryKey: ['leads'] });

      toast.success(`Successfully changed company name.`);
      onClose();
    },
    onError: (error) => {
      console.error(error);
      toast.error(`Error on changing company name. ${error.message}`);
    },
  });

  const handleSubmit = (values: any) => {
    const { companyName } = values;
    editCompanyNameMutation({
      path: updateListing(lead._id),
      method: 'patch',
      body: { companyName },
    });
  };

  if (!isOpen) return null;

  return (
    <Modal open={isOpen} onClose={onClose} title="Edit Company Name">
      <Form
        initialValues={{ companyName }}
        onSubmit={handleSubmit}
        render={({ handleSubmit }) => (
          <form onSubmit={handleSubmit} className="create-lead-form">
            <Field
              name="companyName"
              label="Company name *"
              component={InputField}
              placeholder="e.g. Edge & Node"
              validate={validateRequired('Company name is required.')}
            />

            <Button
              type="submit"
              className="submit-button"
              isLoading={isPending}
            >
              Save
            </Button>
          </form>
        )}
      />
    </Modal>
  );
};

export default EditCompanyNameModal;
